import { useMemo } from 'react'
import { useError } from '@ztechapps/common.hook'
import { PurchaseOrderStatusEnum } from '@ztechapps/common.contract'
import type { ApolloError } from '@apollo/client/errors'
import type { PurchaseOrderStatusDetailType } from '@ztechapps/purchase-order.common'
import { useChangePurchaseOrderStatus, usePurchaseOrderDocument } from '@ztechapps/purchase-order.common'
import { PurchaseOrderStatus } from '@ztechapps/purchase-order.common'
import filter from 'lodash/filter'

type OnUpdate = (value: PurchaseOrderStatusEnum) => Promise<void>
export type UseUpdatePurchaseOrderStatusProps = {
  onUpdate: OnUpdate
  statusMenu: PurchaseOrderStatusDetailType[]
  loading: boolean
  error: ApolloError
}
export const useUpdatePurchaseOrderStatus = ({
  purchaseOrderId,
}: {
  purchaseOrderId: string
}): UseUpdatePurchaseOrderStatusProps => {
  const { document } = usePurchaseOrderDocument({ _id: purchaseOrderId })

  const [updateStatus, , { error, loading }] = useChangePurchaseOrderStatus()
  useError(error)

  const onUpdate: OnUpdate = async (value) => {
    if (value !== document?.status || value !== PurchaseOrderStatusEnum.Received) {
      await updateStatus({
        input: {
          filter: {
            _id: document?._id,
          },
          targetState: value,
        },
      })
    }
  }

  const statusMenu = useMemo<PurchaseOrderStatusDetailType[]>(() => {
    return filter(PurchaseOrderStatus, () => true)
  }, [])

  return { onUpdate, statusMenu, loading, error }
}
